import { Skeleton } from '@/components/ui/skeleton';

interface PageSkeletonProps {
  minimal?: boolean;
}

export function PageSkeleton({ minimal }: PageSkeletonProps) {
  if (minimal) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="w-full max-w-md space-y-4 p-8">
          <Skeleton className="h-8 w-3/4 mx-auto" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-1/2 mx-auto" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <Skeleton className="h-8 w-64" />
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
      <Skeleton className="h-64 w-full" />
    </div>
  );
}

export function AppLayoutSkeleton() {
  return (
    <div className="flex h-screen gap-3.5 bg-(--app-bg) p-0 md:p-3.5">
      {/* Sidebar skeleton */}
      <div className="hidden w-[236px] shrink-0 space-y-4 rounded-3xl bg-(--sidebar-bubble) p-4 md:block">
        <Skeleton className="h-10 w-full rounded-full" />
        <div className="space-y-2">
          <Skeleton className="h-11 w-full rounded-full" />
          <Skeleton className="h-11 w-full rounded-full" />
          <Skeleton className="h-11 w-full rounded-full" />
          <Skeleton className="h-11 w-full rounded-full" />
        </div>
      </div>
      {/* Content skeleton */}
      <div className="flex-1 bg-(--main-bg) p-(--main-pad) md:rounded-(--main-radius) md:[border:var(--main-border)]">
        <PageSkeleton />
      </div>
    </div>
  );
}
